import React from "react";
import { ComboBox as MSComboBox } from "@fluentui/react";
import { useField } from "formik";

function createFakeEvent({ name }) {
  return { target: { name } };
}

const ComboBox = (props) => {
  const [field, meta, helpers] = useField(props);
  const selectedKeys = field.value || [];

  const onChange = React.useCallback(
    (ev, option) => {
      helpers.setValue(
        option === null || option === void 0 ? void 0 : option.key
      );
    },
    [helpers]
  );

  const onChangeMultiSelect = React.useCallback(
    (event, item) => {
      if (item) {
        helpers.setValue(
          item.selected
            ? [...selectedKeys, item.key]
            : selectedKeys.filter((key) => key !== item.key)
        );
      }
    },
    [helpers, selectedKeys]
  );
  return (
    <MSComboBox
      selectedKey={field.value}
      defaultSelectedKey={field.value || meta.initialValue}
      onChange={props.multiSelect ? onChangeMultiSelect : onChange}
      onMenuDismiss={() => field.onBlur(createFakeEvent(field))}
      errorMessage={meta.touched && meta.error}
      {...props}
    />
  );
};

export default ComboBox;
